// Composes a runnable HTML document from the project's files by inlining
// local styles.css and app.js references so it renders correctly in an iframe.
export function buildPreview(files) {
  if (!files || !files.length) return "<html><body></body></html>";
  const index = files.find((f) => f.path.endsWith("index.html")) || files.find((f) => f.path.endsWith(".html"));
  if (!index) {
    return `<!doctype html><html><body style="font-family:sans-serif;background:#07090E;color:#94a3b8;display:flex;align-items:center;justify-content:center;height:100vh;margin:0">No index.html to preview</body></html>`;
  }
  let html = index.content;
  files.forEach((f) => {
    const name = f.path.split("/").pop();
    if (f.path.endsWith(".css")) {
      const re = new RegExp(`<link[^>]*href=["'][^"']*${name}["'][^>]*>`, "g");
      html = html.replace(re, () => `<style>\n${f.content}\n</style>`);
    }
    if (f.path.endsWith(".js")) {
      const re = new RegExp(`<script[^>]*src=["'][^"']*${name}["'][^>]*>\\s*</script>`, "g");
      html = html.replace(re, () => `<script>\n${f.content}\n</script>`);
    }
  });
  return html;
}
